import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { SellerApiService } from '../service/seller-api.service';
import { CognitoUtil } from '../../authentication/service/cognito.service';
import { ProfileUser } from '../../authentication/index';
import { chart } from 'highcharts';
import * as Highcharts from 'highcharts';
import { } from 'googlemaps';
import { MapsAPILoader, AgmMap, AgmInfoWindow } from '@agm/core';
import { FormControl, NgForm } from '@angular/forms';
import { StripeService, ElementOptions, ElementsOptions, StripeCardComponent } from 'ngx-stripe';
import { TranslateService } from '@ngx-translate/core';
// jQuery Sign $
declare let $: any;

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  @ViewChild('chartTarget') chartTarget: ElementRef;
  @ViewChild('Deletemodal') openDeleteModal: ElementRef;
  @ViewChild('DeleteCertificatemodal') deleteCertificatemodal: ElementRef;
  @ViewChild('RemoveServiceAreamodal') openDeleteServiceAreaModal: ElementRef;
  @ViewChild('closeTimeReportModal') closeTimeReportModal: ElementRef;
  @ViewChild('closeCertificateModal') closeCertificateModal: ElementRef;
  @ViewChild('closeExtraServiceArea') closeExtraServiceArea: ElementRef;
  @ViewChild('closeaddCardInformation') closeaddCardInformation: ElementRef;
  @ViewChild('RemoveSellerProfilePicture') RemoveSellerProfilePicture: ElementRef;

  chart: Highcharts.ChartObject;

  user: ProfileUser = new ProfileUser();
  currentUserName: string;
  // tslint:disable-next-line:no-inferrable-types
  isShowSummary: boolean = false;
  // tslint:disable-next-line:no-inferrable-types
  isShowProfileItem: boolean = false;
  // tslint:disable-next-line:no-inferrable-types
  isShowWorkData: boolean = false;

  bussinessinfo: any = {};
  address: any = {
    streetname: '',
    zipcode: '',
    city: '',
    state: ''
  };
  url: string;
  fileData: Array<any> = [];
  fileWorkUpload: Array<any> = [];
  uploadedimages: Array<any> = [];
  viewimageFilePath: string;
  loaderActivate: boolean;
  // tslint:disable-next-line:no-inferrable-types
  errorMessage: string = '';
  // tslint:disable-next-line:no-inferrable-types
  summary: string = '';
  worker_image_id: number;
  workerimage_index: number;
  summarylength: number;
  // tslint:disable-next-line:no-inferrable-types
  summarytoDb: string = '';

  // Service Area Map
  serviceAreasBySeller: any = [];
  displayedserviceAreasBySeller: any = [];
  dummyserviceAreasBySeller: any = [];

  // extendedserviceAreasBySeller: any = [];
  // extendeddummyserviceAreasBySeller: any = [];

  listAllServiceAreas: any = [];
  filteredServiceAreas: any = [];
  searchModal: string;
  public latitude: number;
  public longitude: number;
  public zoom: number;
  public searchControl: FormControl;
  @ViewChild(AgmMap) serviceAreaMap: any;
  public mapInfoWindow: any = { isOpen: false, lat: 0, lng: 0, text: '', service_map_id: ''};
  isAddOrRemoveBtn: boolean;
  activeIndexSelected: number = null;
  isActiveItemSelected: boolean;
  infoWindowOpened: any = null;
  styles: Array<any> = [];
  protected map: any;
  public com_latitude: number;
  public com_longitude: number;
  companyzoom: number;
  reviewList: Array<any> = [];

  pricingList: any = {
    service_area_fee: '',
    time_report_fee: ''
  };
  workerlist: Array<any> = [];
  selectedWorker: Array<any> = [];
  initialSelectedWorker: Array<any> = [];
  numberOfWorker: number;
  timeReport: any = {
    // numberofWorker: 0,
    is_time_reporting_enabled: false,
    worker_ids: [],
    seller_id: null
  };
  currentSellerId: string;
  // tslint:disable-next-line:no-inferrable-types
  errormessagetimereporting: string = '';
  filetoupload: any;
  certificates: Array<any> = [];
  certificateTypes: Array<any> = [];
  is_edit_certificate: boolean;
  certificateObj: any = {};
 // tslint:disable-next-line:no-inferrable-types
  errormessageCertificate: string = '';
  certificate_id: number;
  settingData: any = {
    is_time_report_enabled: 0,
    payment_type: '',
    is_service_area_enabled: 0
  };
  previousType: string;
  // tslint:disable-next-line:no-inferrable-types
  errormessageExtraServiceArea: string = '';
  extraServiceArea: any = {
    service_area_quantity: 0,
    is_service_area_enabled: 0,
    seller_id: null
  };
  // tslint:disable-next-line:no-inferrable-types
  extraServiceAreaCount: number = 0;
  totalwithextraServiceAreaCount: number;
  // stripe Implementation
  @ViewChild('paymentprocess') paymentprocess: NgForm;
  @ViewChild(StripeCardComponent) card: StripeCardComponent;
  paymentInformation: any = {
    payment_method: 'Invoice'
  };
  // tslint:disable-next-line:no-inferrable-types
  invalidValidationMsg: string = '';
  stripeTokenId: string;
  showNumberOfserviceArea: number;

  cardOptions: ElementOptions = {
    style: {
      base: {
        iconColor: '#666EE8',
        color: '#31325F',
        lineHeight: '40px',
        fontWeight: 300,
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSize: '18px',
        '::placeholder': {
          color: '#CFD7E0'
        }
      }
    }
  };

  elementsOptions: ElementsOptions = {
    locale: 'en'
  };
  currentMonth: Date = new Date();

  constructor(private sellerService: SellerApiService,
    private cognitoService: CognitoUtil,
    private stripeService: StripeService, private translate: TranslateService) {

  }

  ngOnInit() {

    console.log(this.extraServiceArea.service_area_quantity);
    // set google maps defaults
    this.zoom = 5;
    this.companyzoom = 5;
    this.latitude = 59.3293;
    this.longitude = 18.0686;
    this.dummyserviceAreasBySeller = [];
    this.showNumberOfserviceArea = 0;
    // tslint:disable-next-line:prefer-const
    let userDetails = this.cognitoService.getCurrentUser();
    if (userDetails != null) {
      this.currentUserName = userDetails.username;
      this.getPreviousWorkersGalleries(userDetails.username);
      this.getProfileSummary(userDetails.username);
      this.getAllServiceAreasAddedByseller(userDetails.username);
      this.callreviewDetailsByusername(userDetails.username);
      this.getSetttingDetails(userDetails.username);
      this.getAllServiceArea();
      this.getServiceAreaCount(userDetails.username);
      this.getPricingListForSetting();
      // get User Details By username
      this.loaderActivate = true;
      this.sellerService.getProfileDetails(userDetails.username).finally(() => {
        this.loaderActivate = false;
      }).subscribe(res => {
        if (res != null) {
          this.user = res;
          // this.getBussinessInformationByBussinessId('5569617474');
          this.getBussinessInformationByBussinessId(this.user.company_registration_no);
          if (this.user.address != null) {
            // tslint:disable-next-line:prefer-const
            let addressobj = this.user.address.split(',');
            this.address.streetname = addressobj[0];
            this.address.zipcode = addressobj[1];
            this.address.city = addressobj[2];
           // this.address. = addressobj[0];
          }
          if (this.user.company_lat !== 0 && this.user.company_lon !== 0) {
            this.com_latitude = this.user.company_lat;
            this.com_longitude = this.user.company_lon;
            this.latitude = this.user.company_lat;
            this.longitude = this.user.company_lon;
          } else {
            this.com_latitude = this.latitude;
            this.com_longitude = this.longitude;
          }
          this.currentSellerId = this.user.seller_id;
          this.getAllWorkersBySellerId(this.user.seller_id);
          this.getAllcertificates(this.user.seller_id);
          this.getAllcertificateTypes(this.user.seller_id);
          this.getAllSelectedWorkerList(this.currentSellerId);

        }
      }, err => {
        console.log(err);
      });
    }
  }

  // Get All Service Areas
  getAllServiceArea() {
    this.loaderActivate = true;
    this.sellerService.getAllServiceAreasMap().finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      this.listAllServiceAreas = res;
      if (res.length > 0) {
        this.listAllServiceAreas.forEach(serviceArea => {
          serviceArea.polygon_points_modified = [];
          if (serviceArea.polygon_points) {
              serviceArea.polygon_points.forEach(element => {
                  serviceArea.polygon_points_modified.push({ lat: +element[1], lng: +element[0] });
              });
          }
      });
        this.filteredServiceAreas = this.listAllServiceAreas;
      }
    }, err => {
      console.log(err);
    });
  }



  mapReady(map) {
    this.map = map;
  }

  assignCopy() {
    this.filteredServiceAreas = Object.assign([], this.listAllServiceAreas);
  }

  // filter item
  filterItem(event) {

    // tslint:disable-next-line:prefer-const
    let value = event.query;
    // tslint:disable-next-line:curly
    if (!value) this.assignCopy(); // when nothing has typed
    this.filteredServiceAreas = Object.assign([], this.listAllServiceAreas).filter(
      item => item.area_name.toLowerCase().indexOf(value.toLowerCase()) > -1
    );

    if (this.filteredServiceAreas.length === 1) {
      if (this.map) {
        const position = new google.maps.LatLng(this.filteredServiceAreas[0].main_lat,  this.filteredServiceAreas[0].main_lon );
        this.map.panTo(position);
      }
    }
    this.isActiveItemSelected = false;
    this.zoom = 5;

  }
  filterItemOnselect(event) {
    if (this.map) {
      const position = new google.maps.LatLng(event.main_lat,  event.main_lon );
      this.map.panTo(position);
    }
    // tslint:disable-next-line:prefer-const
    let value = event.area_name;
    // tslint:disable-next-line:curly
    if (!value) this.assignCopy(); // when nothing has typed
    this.filteredServiceAreas = Object.assign([], this.listAllServiceAreas).filter(
      item => item.area_name.toLowerCase().indexOf(value.toLowerCase()) > -1
    );

    if (this.filteredServiceAreas.length > 1) {
      this.filteredServiceAreas = this.filteredServiceAreas.filter(
        item => item.area_name.toLowerCase() === value.toLowerCase()
      );
    }
    this.zoom = 7;
  }

  // Selected from side menu
  callSelectedItemFilter(item, index: number) {
    if (!this.isActiveItemSelected) {
      this.activeIndexSelected = index;
      this.isActiveItemSelected = true;
      this.filterItemOnselect(item);
      this.latitude = item.main_lat;
      this.longitude = item.main_lon;
      if (this.map) {
        const position = new google.maps.LatLng(item.main_lat,  item.main_lon );
        this.map.panTo(position);
      }
    } else {
      if (this.activeIndexSelected !== index) {
        this.activeIndexSelected = index;
        this.isActiveItemSelected = true;
        this.filterItemOnselect(item);
        if (this.map) {
          const position = new google.maps.LatLng(item.main_lat,  item.main_lon );
          this.map.panTo(position);
        }
      } else {
        this.isActiveItemSelected = false;
        this.activeIndexSelected = index;
        this.assignCopy();
        if (this.map) {
          const position = new google.maps.LatLng( this.latitude,  this.longitude );
          this.map.panTo(position);
          this.zoom = 5;
        }
      }
    }
  }
  // Search in put
  callClearAutocomplete() {
    this.searchModal = null;
    if (this.map) {
      const position = new google.maps.LatLng(this.latitude,  this.longitude);
      this.map.panTo(position);
    }
    this.assignCopy();
    this.isActiveItemSelected = false;
    this.zoom = 5;
  }

  callOnclearInput(event) {
    if (this.map) {
      const position = new google.maps.LatLng(this.latitude,  this.longitude);
      this.map.panTo(position);
    }
    this.assignCopy();
    this.isActiveItemSelected = false;
    this.zoom = 5;
  }
  // Show Modal in side the Map Add to remove
    // show info window when service area clicked
  public showInfoWindow(clickedServiceArea: any, infoWindow: AgmInfoWindow) {

    // this.ngZone.runOutsideAngular(() => {
    //   infoWindow.close();
    // });
    // if (this.infoWindowOpened !== null) {
    //   this.infoWindowOpened.close();
    // }

    this.isAddOrRemoveBtn = false;
    this.serviceAreasBySeller.filter(item => {
      if (item.area_name.toLowerCase() === clickedServiceArea.area_name.toLowerCase()) {
        this.isAddOrRemoveBtn = true;
        return;
      }
    });

    this.mapInfoWindow.isOpen = true;
    this.mapInfoWindow.lat = +clickedServiceArea.main_lat;
    this.mapInfoWindow.lng = +clickedServiceArea.main_lon;
    this.mapInfoWindow.text = clickedServiceArea.area_name;
    this.mapInfoWindow.service_map_id = clickedServiceArea.service_map_id;
  }


  // Get the Service Area Added By Seller
  getAllServiceAreasAddedByseller(username: string) {
    this.dummyserviceAreasBySeller = [];
    this.sellerService.getAllServiceAreasMapByUserName(username).subscribe(res => {
      this.serviceAreasBySeller = res;
      if (res.length > 0) {
        this.serviceAreasBySeller.forEach(serviceArea => {
          serviceArea.polygon_points_modified = [];
          if (serviceArea.polygon_points) {
            serviceArea.polygon_points.forEach(element => {
              serviceArea.polygon_points_modified.push({ lat: +element[1], lng: +element[0] });
            });
          }
        });

        if (typeof this.totalwithextraServiceAreaCount === 'undefined') {
          if (this.serviceAreasBySeller.length < 5) {
            for (let index = 0; index < 5 - this.serviceAreasBySeller.length; index++) {
              const element = { id: index };
              this.dummyserviceAreasBySeller.push(element);
            }
          }
        } else {
          // tslint:disable-next-line:prefer-const
          let mark = this.totalwithextraServiceAreaCount;
          if (this.serviceAreasBySeller.length < mark) {
            for (let index = 0; index < mark - this.serviceAreasBySeller.length; index++) {
              const element = { id: index };
              this.dummyserviceAreasBySeller.push(element);
            }
          }
        }


      } else {
        // tslint:disable-next-line:prefer-const
        let mark = 5;
        if (this.serviceAreasBySeller.length < mark) {
          for (let index = 0; index < mark - this.serviceAreasBySeller.length; index++) {
            const element = { id: index };
            this.dummyserviceAreasBySeller.push(element);
          }
        }
      }


    }, err => {
      console.log(err);
    });
  }

  // Call Empty Load
  onCallDataLoadExtra() {
    this.dummyserviceAreasBySeller = [];
    // tslint:disable-next-line:prefer-const
    let mark = this.totalwithextraServiceAreaCount;
    if (this.serviceAreasBySeller.length < mark) {
      for (let index = 0; index < mark - this.serviceAreasBySeller.length; index++) {
        const element = { id: index };
        this.dummyserviceAreasBySeller.push(element);
      }
    }
  }

  // close
  callClickButtontoClose(): void {
    this.mapInfoWindow.isOpen = false;
  }

  // Call the Remove Button Modal Calling
  callRemoveButtonModal(): void {
    this.mapInfoWindow.isOpen = false;
    $(this.openDeleteServiceAreaModal.nativeElement).modal('show');

  }

  // Call Remove Button by Item
  callRemoveButtonModalByItem(item: any) {
    this.mapInfoWindow.text = item.area_name;
    this.mapInfoWindow.service_map_id = item.service_map_id;
    $(this.openDeleteServiceAreaModal.nativeElement).modal('show');
  }

  confirmToRemoveServiceArea(): void {
    this.loaderActivate = true;
    this.sellerService.deleteServiceAreaMapByUserId(this.currentUserName, this.mapInfoWindow.service_map_id).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res === 200) {
        this.getAllServiceAreasAddedByseller(this.currentUserName);
        this.mapInfoWindow.isOpen = false;
        $(this.openDeleteServiceAreaModal.nativeElement).modal('hide');
        this.isActiveItemSelected = false;
        this.assignCopy();
        if (this.map) {
          const position = new google.maps.LatLng( this.latitude,  this.longitude );
          this.map.panTo(position);
          this.zoom = 5;
        }
      }
    }, err => {
      console.log(err);
      $(this.openDeleteServiceAreaModal.nativeElement).modal('hide');
    });
  }

  declineDeleteServiceArea(): void {
    this.mapInfoWindow.isOpen = false;
    $(this.openDeleteServiceAreaModal.nativeElement).modal('hide');
  }

  // Add the Service Area Map
  CallAddServiceAreaMap(): void {
    // tslint:disable-next-line:prefer-const
    let service_map_ids = [];
    service_map_ids.push(this.mapInfoWindow.service_map_id);
    if (this.serviceAreasBySeller.length === this.totalwithextraServiceAreaCount) {
      return;
    }
    this.addServiceAreaByUserName(this.currentUserName, service_map_ids);
  }

  // Add the service area by parameters
  addServiceAreaByUserName(username: string, service_map_ids: any) {
    this.loaderActivate = true;
    this.sellerService.addServiceAreaMapByUserId(username, service_map_ids).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res === 200) {
        this.getAllServiceAreasAddedByseller(this.currentUserName);
        this.mapInfoWindow.isOpen = false;
      }
    }, err => {
      console.log(err);
    });
  }

  // Fille the Color For Service Area
  fileColorForSellerServiceArea(areaservice: any): string {
    if (this.contains(areaservice)) {
      return '#97b0c6';
    } else {
      return '#fff';
    }

  }



  fillOpacityForSellerServiceArea(areaservice: any): number {
    if (this.contains(areaservice)) {
      return 1;
    } else {
      return 0.6;
    }
  }

 contains(aarea) {
    for (let i = 0; i < this.serviceAreasBySeller.length; i++) {
        if (this.serviceAreasBySeller[i].area_name === aarea.area_name) {
            return true;
        }
    }
    return false;
}

  // Get the Prevois Workers Information
  getPreviousWorkersGalleries(username: string) {
    this.sellerService.getPreviousWorkImages(username).subscribe(res => {
      this.uploadedimages = [];
      this.uploadedimages = res;
    }, err => {
      console.log(err);
    });
  }

  getProfileSummary(username: string) {
    this.sellerService.getProfileSummary(username).subscribe(res => {
      if (res != null) {
        this.summary = res;
      }
    }, err => {
      console.log(err);
    });
  }

  // Get the Business Informatiom
  getBussinessInformationByBussinessId(bussinessid: string) {
    this.sellerService.getBussinessDetailInfomation(bussinessid).subscribe(res => {
      if (res != null) {
        this.bussinessinfo = res;
        this.loadChartData(res.turnover_data_list);
      }
    }, err => {
      console.log(err);
    });
  }

  // Load Quick fact Charts
  loadChartData(dataObject: Array<any>): void {

    // tslint:disable-next-line:prefer-const
    let dataTable: Array<any> = [];
    dataObject.map(function(item){
      dataTable.push([item.year, Number(item.value)]);
     });

    const options: Highcharts.Options = {
      chart: {
        type: 'column',
        height: 200,
        borderRadius: 0,
        spacing: [20, 10, 20, 10]
      },
      title: {
        text: ''
      },
      colors: ['#085f5d', '#085f5d', '#085f5d', '#085f5d', '#085f5d'],
      yAxis: {
        title: {
          text: ''
        }
      },
      xAxis: {
        type: 'category',
      },
      credits: {
        enabled: false
      },
      tooltip: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        column: {
           colorByPoint: true
        }
      },
      series: [
        {
          'name': null, 'data': dataTable
        }

      ]

    };

    this.chart = chart(this.chartTarget.nativeElement, options);

  }



  // Call Summary Disable
  callSummaryDisable(): void {
    if (this.isShowSummary) {
      this.isShowSummary = false;
    }else {
      this.isShowSummary = true;
    }
  }

  // Call Work Disable or Enable
  callWorkDisable(): void {
    if (this.isShowWorkData) {
      this.isShowWorkData = false;
    }else {
      this.isShowWorkData = true;
    }
  }

  // Update summary
  updateProfile(): void {
    if (this.fileData.length > 0) {
      this.callFileUpload();
    }
    // Update Summary
    this.loaderActivate = true;
    this.user.address = this.address.streetname + ',' + this.address.zipcode + ',' + this.address.city + ',' + this.address.state;
    this.sellerService.updateProfile(this.user).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      this.isShowSummary = false;
      this.isShowProfileItem = false;
    }, err => {
      console.log(err);
      this.isShowSummary = false;
      this.isShowProfileItem = false;
    });
  }

  // Delete Profile Pic
  deletprofilepicopenmodal() {
    $(this.RemoveSellerProfilePicture.nativeElement).modal('show');
  }

  // decline
  declineDeleteProfilePic() {
    $(this.RemoveSellerProfilePicture.nativeElement).modal('hide');
  }

  // confirm to delete profile pic
  confirmToRemoveProfilepic() {
    if (this.fileData.length === 0) {
      this.loaderActivate = true;
      this.sellerService.removeSellerProfilePic(this.user.username).finally(() => {
        this.loaderActivate = false;
      }).subscribe(res => {
        $(this.RemoveSellerProfilePicture.nativeElement).modal('hide');
        this.user.image_url = null;
      }, err => {
        console.log(err);
        $(this.RemoveSellerProfilePicture.nativeElement).modal('hide');
        this.user.image_url = null;
      });
    }else {
      $(this.RemoveSellerProfilePicture.nativeElement).modal('hide');
      this.user.image_url = null;
      this.fileData = [];
    }

  }

  // Update Profile Summary
  updateProfileSummary(): void {
    if (this.summary.length > 1000) {
      return;
    }
    // Update Summary
    this.loaderActivate = true;
    this.sellerService.updateProfileSummary(this.user.username, this.summary).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      this.isShowSummary = false;
      this.summary = this.summary;
    }, err => {
      console.log(err);
      this.isShowSummary = false;
    });
  }

  // Call Text Change Summary
  callSummaryTextChange($event) {
     this.summarylength = this.summary.length;
    // this.summarytoDb = $event.textValue;
  }

  // Call the File Upload function || if uploaded
  callFileUpload(): void {
      this.loaderActivate = true;
      this.sellerService.upload_image(this.fileData, this.user.username).finally(() => {
        this.loaderActivate = false;
      }).subscribe(res => {
        this.fileData = [];
      }, err => {
        console.log(err);
      });
  }

  // Call True False
  updateProfileItems(): void {
    if (this.isShowProfileItem) {
      this.isShowProfileItem = false;
    }else {
      this.isShowProfileItem = true;
    }
  }

  // photo upload select file
  onSelectFile(event) {
    this.fileData = [];
    if (event.target.files && event.target.files[0]) {
      this.fileData.push(event.target.files[0]);
      // tslint:disable-next-line:prefer-const
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      // tslint:disable-next-line:no-shadowed-variable
      reader.onload = (event: Event) => { // called once readAsDataURL is completed
        this.user.image_url = reader.result;
      };
    }
  }

  // File Upload for test
  fileUploadChange(event) {
    if (event.target.files && event.target.files[0]) {
      this.errorMessage = '';
      if (this.isValidateFileSizeAndFormat(event.target.files)) {
        for (let index = 0; index < event.target.files.length; index++) {
          // this.fileWorkUpload.push(event.target.files[index]);
          // tslint:disable-next-line:prefer-const
          let filetoupload = event.target.files[index];
          // tslint:disable-next-line:prefer-const
          let reader = new FileReader();
          reader.readAsDataURL(event.target.files[index]); // read file as data url
          // tslint:disable-next-line:no-shadowed-variable
          reader.onload = (event: Event) => { // called once readAsDataURL is completed
            // this.uploadedimages.push({ work_image_file_path: reader.result, work_image_id: 123 });
            // Call the Back End
            this.loaderActivate = true;
            this.sellerService.upload_worker_images(filetoupload, this.user.username).finally(() => {
              this.loaderActivate = false;
              this.fileWorkUpload = [];
            }).subscribe(res => {
              // console.log('successfully updated profile pic : ' + res);
              // this.isShowWorkData = false;
              this.getPreviousWorkersGalleries(this.currentUserName);
            }, err => {
              console.log(err);
            });

          };
        }
      }else {
        // this.errorMessage = 'Please upload less than 2Mb images';
      }
    }
  }

  // View Image By Click
  viewImageFile(filepath) {
    this.viewimageFilePath = filepath;
  }

  // checking File size to view
  isValidateFileSizeAndFormat(files: any): boolean {
    for (let index = 0; index < files.length; index++) {
      if (files[index].size >= 2097152) {
        let msge = '';
        // let msge1 = '';
        this.translate.get('Profile.Pleaseuploadthanimages').subscribe(res => {
             msge = res;
        });
    //     this.translate.get('Profile.Pleaseuploadthanimages1').subscribe(res => {
    //       msge1 = res;
    //  });
        this.errorMessage = msge;
        return false;
      }

      // tslint:disable-next-line:prefer-const
      let extention = files[index].name.substring(
        files[index].name.lastIndexOf('.') + 1).toLowerCase();
      if (extention === 'gif' || extention === 'png'
        || extention === 'jpeg' || extention === 'jpg') {
      } else {
        this.translate.get('Profile.ImageuploadType').subscribe(res => {
          this.errorMessage = res;
        });
       // this.errorMessage = String(this.translate.get('Profile.ImageuploadType'));
        return false;
      }
    }
    return true;
  }

  // File Upload Images

  callFileUploadWorker(): void {
    this.isShowWorkData = false;
    this.errorMessage = '';
    if (this.fileWorkUpload.length > 0) {
      // this.loaderActivate = true;
      // this.sellerService.upload_worker_images(this.fileWorkUpload, this.user.username).finally(() => {
      //   this.loaderActivate = false;
      //   this.fileWorkUpload = [];
      // }).subscribe(res => {
      //   console.log('successfully updated profile pic : ' + res);
      //   this.isShowWorkData = false;
      // }, err => {
      //   console.log(err);
      // });
    } else {
      this.isShowWorkData = false;
    }
  }

  // Call the delete worker image _id
  callDeleteFileByimageid(work_image_id: number, index: number): void {
    this.worker_image_id = work_image_id;
    this.workerimage_index = index;
    $(this.openDeleteModal.nativeElement).modal('show');
  }

  confirmDeleteImage(): void {
    if (this.worker_image_id != null) {
      this.loaderActivate = true;
      this.sellerService.deleteworkerimagebyimageid(this.user.username, this.worker_image_id).finally(() => {
        this.loaderActivate = false;
      }).subscribe(res => {
        $(this.openDeleteModal.nativeElement).modal('hide');
        this.isShowWorkData = false;
        this.uploadedimages.splice(this.workerimage_index, 1);
      }, err => {
        console.log(err);
        $(this.openDeleteModal.nativeElement).modal('hide');
      });
    }
  }

  declineDeleteImage(): void {
    $(this.openDeleteModal.nativeElement).modal('hide');
  }

  // Call the list of review details By username
  callreviewDetailsByusername(username) {
    this.sellerService.getReviewListBySellerUsername(username).subscribe(res => {
      if (res != null) {
        this.reviewList = res;
      }
    }, err => {
      console.log(err);
    });
  }

  // calculate the Percentage
  getPercentageValue(value) {
    return (value / 5) * 100;
  }

  // Calculating FinalRating
  getFinalRatingValue(item) {
    // tslint:disable-next-line:prefer-const
    let value = item.rate_final_result + item.rate_treatment + item.rate_price +
      item.rate_time + item.rate_communication + item.rate_recommendation;
    return ((value / 30) * 5).toFixed(1);
  }

  // Final Display Value Changes
  getFinalValueDisplayStar(item) {
    // tslint:disable-next-line:prefer-const
    let value = item.rate_final_result + item.rate_treatment + item.rate_price +
      item.rate_time + item.rate_communication + item.rate_recommendation;
    // tslint:disable-next-line:prefer-const
    let finalvalue = ((value / 30) * 5).toFixed(1);
    const costpart = String(finalvalue).split('.');
    // tslint:disable-next-line:prefer-const
    let findarray = [];
    for (let index = 0; index < Number(costpart[0]); index++) {
      findarray.push({ name: 'full' });
      if (index === Number(costpart[0]) - 1 && Number(costpart[1]) > 0) {
        findarray.push({ name: 'half' });
      }
    }
    if (findarray.length !== 5) {
      findarray.push({ name: 'empty' });
    }
    return findarray;
  }

  getFinalOutFromEach(value) {
    let sum = 0;
    // tslint:disable-next-line:prefer-const
    let findarray = [];
    this.reviewList.forEach(each => {
      sum += each[value];
    });
    const quotient = Math.floor(sum / this.reviewList.length);
    const remainder = sum % this.reviewList.length;
    for (let index = 0; index < quotient; index++) {
      findarray.push({name: 'full'});
      if (index === quotient - 1 && remainder > 0) {
        findarray.push({name: 'half'});
      }
    }

    if (findarray.length !== 5) {
      // tslint:disable-next-line:prefer-const
      let fineval = findarray.length;
      for (let index = 0; index < 5 - fineval; index++) {
        findarray.push({name: 'empty'});
      }
    }

    return findarray;
  }

  //#region  Time Reporting
  // Decrease
  decreaseTimeReportingValue() {
    if (this.timeReport.numberofWorker > 0) {
      this.timeReport.numberofWorker = this.timeReport.numberofWorker - 1;
    }
  }

  increaseTimeReportingValue() {
      this.timeReport.numberofWorker = this.timeReport.numberofWorker + 1;
  }

  // Get the Pricing Lis
  getPricingListForSetting() {
    this.sellerService.getPricingListForSetting().subscribe(res => {
      this.pricingList = res;
    }, err => {
      console.log(err);
    });
  }

  // get All Workers with Project Lead
  getAllWorkersBySellerId(sellerId) {
    this.sellerService.getWorkerListForTimeReporting(sellerId).subscribe(res => {
      this.workerlist = res;
    }, err => {
      console.log(err);
    });
  }

  // Already selected Worker List
  getAllSelectedWorkerList(sellerId) {
    this.selectedWorker = [];
    this.initialSelectedWorker = [];
    this.sellerService.getWorkerListSelectedTimeReport(sellerId).subscribe(res => {
      if (res != null && res.length > 0) {
        res.map((item) => {
          // tslint:disable-next-line:prefer-const
          let obj = this.workerlist.find(x => x.user_id === item.user_id);
          this.selectedWorker.push(obj);
          this.initialSelectedWorker.push(obj);
        });
      }
    }, err => {
      console.log(err);
    });
  }

  submitTimeReportingFeature() {
    this.errormessagetimereporting = '';
    if (this.initialSelectedWorker.length === 0 && this.selectedWorker.length === 0) {
      this.translate.get('Profile.SelectWorker').subscribe(res => {
        this.errormessagetimereporting = res;
      });
      return;
    }
    // tslint:disable-next-line:prefer-const
    let workerids = this.selectedWorker.map((item) => {
      return item.worker_id;
    });

    const body = {
      seller_id: this.currentSellerId,
      is_time_reporting_enabled: 1,
      worker_ids: workerids
    };
    this.loaderActivate = true;
    this.sellerService.updateTimeReportOnOffMethod(body).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {

      if (this.initialSelectedWorker.length > this.selectedWorker.length) {
        this.RemoveTimeReportingUpdate(this.currentSellerId, (this.initialSelectedWorker.length - this.selectedWorker.length));
      } else {
        this.AddTimeReportingUpdate(this.currentSellerId, (this.selectedWorker.length - this.initialSelectedWorker.length ));
      }
      console.log(res);
      this.closeTimeReportModal.nativeElement.click();
      this.getSetttingDetails(this.currentUserName);
      this.getAllSelectedWorkerList(this.currentSellerId);
    }, err => {
      console.log(err);
    });
  }


  //#endregion

  //#region Service Area Extra
  decreaseValue() {
    if (this.extraServiceArea.service_area_quantity > 0) {
      this.extraServiceArea.service_area_quantity = this.extraServiceArea.service_area_quantity - 1;
      this.showNumberOfserviceArea = 5 + this.extraServiceArea.service_area_quantity;
    }
  }

  increaseValue() {
    console.log(this.extraServiceArea.service_area_quantity);
    this.extraServiceArea.service_area_quantity = this.extraServiceArea.service_area_quantity + 1;
    this.showNumberOfserviceArea = 5 + this.extraServiceArea.service_area_quantity;
  }
  // Display Number Of Service Area
  onchangeServiceAreacount($event) {
    this.showNumberOfserviceArea = 5 + this.extraServiceArea.service_area_quantity;
  }
  setDefaultValue() {
    this.showNumberOfserviceArea = this.totalwithextraServiceAreaCount;
    this.extraServiceArea.service_area_quantity = this.showNumberOfserviceArea - 5;
    this.errormessageExtraServiceArea  = '';
  }

    // get the Service Area Count
    getServiceAreaCount(username) {
      // this.dummyserviceAreasBySeller = [];
      this.sellerService.getServiceAreaCount(username).subscribe(res => {
        if (res.length > 0) {
          this.totalwithextraServiceAreaCount = res[0] + res[1];
          this.showNumberOfserviceArea = this.totalwithextraServiceAreaCount;
          this.extraServiceAreaCount = res[0];
          if (this.totalwithextraServiceAreaCount !== 0) {
            this.dummyserviceAreasBySeller = [];
            for (let index = 0; index < this.totalwithextraServiceAreaCount - this.serviceAreasBySeller.length; index++) {
              const element = { id: index };
              this.dummyserviceAreasBySeller.push(element);
            }
          }
        }
      }, err => {
        console.log(err);
      });
    }

  submitExtraServiceArea() {
    this.errormessageExtraServiceArea = '';
    if (this.extraServiceArea.service_area_quantity === 0 && this.totalwithextraServiceAreaCount === 5) {
      this.translate.get('Profile.selectServiceareamessage').subscribe(res => {
        this.errormessageExtraServiceArea = res;
      });
     // this.errormessageExtraServiceArea = 'Please select at least one Service Area';
      return;
    }

    if (this.extraServiceArea.service_area_quantity + 5 < this.serviceAreasBySeller.length) {
      this.translate.get('Profile.Pleaseremoveextraservicefrommap').subscribe(res => {
        this.errormessageExtraServiceArea = res;
      });
      return;
    }

    if (this.extraServiceArea.service_area_quantity + 5 === this.serviceAreasBySeller.length) {
      if (this.totalwithextraServiceAreaCount > this.extraServiceArea.service_area_quantity + 5) {

      }else {
        this.translate.get('Profile.Pleaseremoveextraservicefrommap').subscribe(res => {
          this.errormessageExtraServiceArea = res;
        });
        return;
      }
    }


    this.loaderActivate = true;
    this.showNumberOfserviceArea = this.extraServiceArea.service_area_quantity + 5;
    this.sellerService.getServiceAreaOnOff(this.currentSellerId, 1, this.extraServiceArea.service_area_quantity).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      this.closeExtraServiceArea.nativeElement.click();
      if (this.totalwithextraServiceAreaCount > this.showNumberOfserviceArea) {
        this.RemoveExtraServiceUpdate(this.currentSellerId, (this.totalwithextraServiceAreaCount - this.showNumberOfserviceArea));
      } else {
        this.AddExtraServiceUpdate(this.currentSellerId, (this.showNumberOfserviceArea - this.totalwithextraServiceAreaCount));
      }
      // this.getServiceAreaCount(this.currentUserName);
      this.totalwithextraServiceAreaCount = this.showNumberOfserviceArea;
      this.extraServiceAreaCount = this.extraServiceArea.service_area_quantity;
        this.dummyserviceAreasBySeller = [];
        // tslint:disable-next-line:max-line-length
        for (let index = 0; index < (this.totalwithextraServiceAreaCount - this.serviceAreasBySeller.length); index++) {
          const element = { id: index };
          this.dummyserviceAreasBySeller.push(element);
        }
      this.getSetttingDetails(this.currentUserName);
    }, err => {
      console.log(err);
    });

  }


  // Update the CRM intergeation
  AddExtraServiceUpdate(sellerid, quantity) {
    this.sellerService.AddCrmExtraServiceArea(sellerid, quantity).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      console.log(res);
    }, err => {
      console.log('Extra Service Add Failed');
    });
  }

  RemoveExtraServiceUpdate(sellerid, quantity) {
    this.sellerService.RemoveCrmExtraServiceArea(sellerid, quantity).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      console.log(res);
    }, err => {
      console.log('Extra Service Remove Failed');
    });
  }

  AddTimeReportingUpdate(sellerid, quantity) {
    this.sellerService.AddCrmTimeReporting(sellerid, quantity).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      console.log(res);
    }, err => {
      console.log('Extra Service Add Failed');
    });
  }

  RemoveTimeReportingUpdate(sellerid, quantity) {
    this.sellerService.RemoveCrmTimeReporting(sellerid, quantity).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      console.log(res);
    }, err => {
      console.log('Extra Service Remove Failed');
    });
  }


  //#endregion

  //#region Certificates

  // certificates
  getAllcertificates(seller_id) {
    this.sellerService.getCertificates(seller_id).subscribe(res => {
      this.certificates = res;
    }, err => {
      console.log(err);
    });
  }

  // get certificate types
  getAllcertificateTypes(seller_id) {
    this.sellerService.getCertificateTypes(seller_id).subscribe(res => {
      this.certificateTypes = res;
    }, err => {
      console.log(err);
    });
  }


// add properties
  certificateUploadChange(event) {
    if (event.target.files && event.target.files[0]) {
      this.errormessageCertificate = '';
      this.filetoupload = event.target.files[0];
    }
  }

  getCertificateFileUrlLink(item) {
    if (item != null) {
      return item;
    } else {
      return 'javascript: void(0)';
    }
  }

  // Upload the Certificate
  uploadCertificates() {
    this.errormessageCertificate = '';
    if (this.certificateObj.certificate_id === undefined || this.certificateObj.certificate_id === null) {
      this.translate.get('Profile.selectCertificateMessage').subscribe(res => {
        this.errormessageExtraServiceArea = res;
      });
      // this.errormessageCertificate = 'Please select the certificate';
      return;
    }
    // if (this.filetoupload === null || this.filetoupload === undefined) {
    //   this.errormessageCertificate = 'Please upload pdf format certificate';
    //   return;
    // }

    const body = {
      certificate_id: this.certificateObj.certificate_id,
      seller_id: this.currentSellerId
    };
    // Call the Back End
    this.loaderActivate = true;
    this.sellerService.addCertificates(body, this.filetoupload).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      this.certificateObj.certificate_id = undefined;
      this.filetoupload = null;
      this.getAllcertificates(this.currentSellerId);
      this.getAllcertificateTypes(this.currentSellerId);
      this.closeCertificateModal.nativeElement.click();
    }, err => {
      console.log(err);
    });
  }


  // Delete the Certicate
  deleteCertificate(item) {
    $(this.deleteCertificatemodal.nativeElement).modal('show');
    this.certificate_id = item.seller_certificate_id;
  }

  // confirmeation delete
  confirmDeleteCertificate() {
    this.loaderActivate = true;
   this.sellerService.deleteCertificate(this.certificate_id).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      this.getAllcertificates( this.currentSellerId);
      this.getAllcertificateTypes(this.currentSellerId);
      $(this.deleteCertificatemodal.nativeElement).modal('hide');
    }, err => {
      console.log(err);
    });
  }

  declineDeleteCertificate() {
    $(this.deleteCertificatemodal.nativeElement).modal('hide');
  }

  // get Show the setting details
  getSetttingDetails(username) {
    this.sellerService.getSettingDatabyUsername(username).subscribe(res => {
      this.settingData = res;
      if (res != null) {
        this.previousType = this.settingData.payment_type;
        if (this.settingData.payment_type !== 'Invoice') {
          this.getStripeAndInvoiceInformation();
        }
      }

    }, err => {
      console.log(err);
    });
  }


  // get Stripe and Invoice Information
  getStripeAndInvoiceInformation() {
    const body = {
      seller_id: this.currentSellerId,
      start_date: '01/11/2018',
      end_date: '30/11/2018'
    };
    // this.sellerService.getCurrentStripeInformation(body).subscribe(res => {
    //   console.log(res);
    // }, err => {
    //   console.log(err);
    // });
  }

  onChangeTimeReporting() {
    if (this.settingData.is_time_report_enabled === 0) {
       this.settingData.is_time_report_enabled = 1;
    } else {
       this.settingData.is_time_report_enabled = 0;
    }
  }

  onChangeServiceArea() {
    if (this.settingData.is_service_area_enabled === 0) {
      this.settingData.is_service_area_enabled = 1;
    } else {
      this.settingData.is_service_area_enabled = 0;
    }
  }


  //#endregion

  // get the Stripe Key and Create a account for stripe
  getTokenFromStripe(model: any, isValid: boolean) {
    this.invalidValidationMsg = '';
    this.stripeTokenId = '';
    if (!isValid) {
      // this.invalidValidationMsg = 'All fields are required';
      return;
    }
    const name = this.paymentInformation.cardholdername;
    this.stripeService
      .createToken(this.card.getCard(), { name })
      .subscribe(result => {
        if (result.token) {
          // Use the token to create a charge or a customer
          // https://stripe.com/docs/charges
          // console.log(result.token.id);
          this.stripeTokenId = result.token.id;
          const body = {
            seller_username: this.currentUserName,
            stripe_source_token: this.stripeTokenId
          };
          this.loaderActivate = true;
          this.sellerService.updatetokenBySellerId(body).finally(() => {
             this.loaderActivate = false;
           }).subscribe(res => {
                this.closeaddCardInformation.nativeElement.click();
                this.getSetttingDetails(this.currentUserName);
           }, err => {
             console.log(err);
           });
        } else if (result.error) {
          // Error creating the token
          console.log(result.error.message);
          this.invalidValidationMsg = result.error.message;
        }
      });
  }

  // Switch to Card Payment Method!!!
  onChangeCardPayment() {
    if (this.settingData.payment_type === 'Stripe') {
      this.settingData.payment_type = 'Invoice';
    } else {
      this.settingData.payment_type = 'Stripe';
    }
  }

  // Swtich Invoice To Card Option
  onChangeInvoiceFromCard() {
    this.settingData.payment_type = 'Invoice';
    this.loaderActivate = true;
    this.sellerService.changeSwitchtoInvoiceFromCard(this.currentSellerId).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        console.log(res);
        this.settingData.payment_type = 'Invoice';
      }

    }, err => {
      console.log(err);
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/seller/profile/profile.component.ts